import { render, staticRenderFns } from "./Pengurus.vue?vue&type=template&id=7f8ac2ae"
import script from "./Pengurus.vue?vue&type=script&lang=js"
export * from "./Pengurus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports